import styled from 'styled-components';
import { Palette } from 'config';

export const SearchIconWraper = styled.div`
  svg {
    fill: ${Palette.PrimaryGray._900};
  }
  margin-left: 18px;
  flex-basis: 1%;
`;

export const WrapForRightIcon = styled.div`
  margin-left: 10px;
  margin-right: 16px;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid ${Palette.PrimaryGray._200};
`;

export const SearchInput = styled.input`
  height: 48px;
  color: ${() => Palette.PrimaryGray._900};
  font-weight: normal;
  font-size: 0.875em;
  line-height: 1.25em;
  border: none;
  border-top-color: transparent;
  background: #fff;
  padding: 6px 18px;
  flex-grow: 1;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${() => Palette.PrimaryGray._900};
    font-weight: 400;
    font-size: 0.875em;
    line-height: 1.25em;
  }
`;

export const ClearSearchInputWrapper = styled.div`
  visibility: ${({ visible }) => (!visible ? 'hidden' : 'visible')};
  svg {
    fill: ${() => Palette.PrimaryGray._400};
  }
  &:hover {
    svg {
      fill: ${() => Palette.PrimaryGray._500};
    }
    background: ${() => Palette.PrimaryGray._100};
  }
  &:active {
    svg {
      fill: ${() => Palette.Primary._500};
    }
    background: ${() => Palette.Primary._000};
  }
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 34px;
  cursor: pointer;
  margin-left: auto;
  transition: all 0.2s linear;
`;
